import { Slot } from 'expo-router'

export default function () {
  return <Slot />
}
